import * as ls from "local-storage";
import { store } from "redux/store";

import { apiInterceptor } from 'utils/apiInterceptor';
/**
 * gets the list of reports
 */
export async function getReports(data) {
  const auth = ls.get("auth");
  const project = ls.get("project");
  const user = store?.getState()?.user

  if (auth && user) {
    const authBearer = `Bearer ${auth.access_token}`;
    const projectId = project.projectId;

    const page = data.page ? data.page : 1;
    const sizePerPage = data.sizePerPage ? data.sizePerPage : 10;

    const response = await apiInterceptor(
      `${process.env.REACT_APP_MYXP_API}/manager/reports/${projectId}?limit=${sizePerPage}&page=${page}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: authBearer
        },
        body: JSON.stringify(data)
      }
    );

    return await response.json();
  }
}
